import useFieldState from '@/common/hooks/hook-wrappers/useInformedFieldStateWrapper';
import { useIsMobile } from '@/hooks/use-is-mobile';
export const PopularSearches = ({ onPopularSearchClick }: { onPopularSearchClick: (searchQuery: string) => void }) => {
  const { value } = useFieldState('search_query');
  const { isMobile } = useIsMobile();
  const popularKeys = isMobile
    ? ["men's steel toe work boots", "kids' rainboots", "women's farm boots", 'hunting waders']
    : ["men's steel toe work boots", "women's farm boots", "kids' rainboots", 'hunting waders'];
  if (value) {
    return null;
  }

  return (
    <div className='autocomplete_root_visible__NYP1u autocomplete_root__RXJ93 mt-[20px] lg_mt-[40px]'>
      <p className='mb-[20px] hidden font-roboto-medium text-[20px] font-medium leading-[28px] lg_block'>
        Popular Searches
      </p>
      <div className='align-center mb-[20px] flex flex-wrap justify-start gap-[8px] lg_gap-[20px]'>
        {popularKeys.map((item, index) => (
          <span
            key={index}
            onClick={() => onPopularSearchClick(item)}
            className=' h-[40px] cursor-pointer rounded-full bg-[#F9F9F9] px-[14px] font-roboto-regular text-[14px] capitalize leading-[40px] lg_h-[50px] lg_px-[20px] lg_text-[16px] lg_leading-[50px]'
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};
